import { Component, Inject, OnInit, AfterViewInit, AfterViewChecked, AfterContentInit, inject, effect } from '@angular/core';
/*import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';
*/
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import PerfectScrollbar from 'perfect-scrollbar';
import {
  HasRolesDirective,
  KEYCLOAK_EVENT_SIGNAL,
  KeycloakEventType,
  typeEventArgs,
  ReadyArgs
} from 'keycloak-angular';
import Keycloak, { KeycloakProfile } from 'keycloak-js';

import { environment } from '../../environments/environment';
import { RouterLink, RouterLinkActive, provideRouter } from '@angular/router';
import { NgIf, NgFor } from '@angular/common';
import { UserModel } from '../shared/models/user';
import { OrganizationModel } from '../shared/models/organization';

declare var $: any;
//Metadata
export interface RouteInfo {
    path: string;
    requireLogin: boolean;
    RouteRoles: RouteRoleItems[];
    title: string;
    type: string;
    icontype: string;
    // icon: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
    RouteRoles: RouteRoleItems[];
}

export interface RouteRoleItems {
    RouteRole: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
        path: '/dashboard',
        requireLogin: false,
        RouteRoles: [{ RouteRole: '' }],
        title: 'Dashboard',
        type: 'link',
        icontype: 'ti-panel'        
    },{
        //path: '/usermanagement',
        path: '/usermanagement/userdetail',
        requireLogin: true,
        RouteRoles: [{ RouteRole: 'SRNHelpdesk' }],
        title: 'User-Management',
        //type: 'sub',
        type: 'link',
        icontype: 'ti-user'
    },{
        path: '/portalmanagement',
        requireLogin: true,
        RouteRoles: [{ RouteRole: 'SRNHelpdesk' }],
        title: 'Portal-Management',
        type: 'sub',
        icontype: 'ti-settings',
        children: [
            { path: 'aadmanagement', title: 'AAD Management', ab: 'AM', RouteRoles: [{ RouteRole: '' }] },
            { path: 'eupidmanagement', title: 'EUPID Management', ab: 'EM', RouteRoles: [{ RouteRole: '' }] },
            { path: 'log', title: 'Log', ab: 'LG', RouteRoles: [{ RouteRole: '' }] },
        ]
    },{
        path: '/patientmanagement/patientregistration',
        requireLogin: true,
        RouteRoles: [{ RouteRole: 'BIOPORTALUser' }, { RouteRole: 'MONAUser' }, { RouteRole: 'HRNBL2User' }],
        title: 'Patient registration',
        type: 'link',
        icontype: 'ti-settings'
    }
];

@Component({
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    imports: [RouterLink, NgIf, NgFor, RouterLinkActive, HasRolesDirective  ]
})

export class SidebarComponent {
    public menuItems: any[];
    instance: string;
    private roles: any[];
    private readonly _destroying$ = new Subject<void>();
    
    public userProfileKeycloak: KeycloakProfile | null = null;

    keycloakStatus: string | undefined;
    private readonly keycloak = inject(Keycloak);
    private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);

    isNotMobileMenu(){
        if (window.outerWidth > 991){
            return false;
        }
        return true;
    }
    constructor(
        /*
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private msalService: MsalService,
        private msalBroadcastService: MsalBroadcastService*/
    ) {
        this.instance = environment.instanceString;
        
        
        /*
        this.msalService.instance.initialize()
            .then(response => {
                //
            })
            .catch((error) => {
                console.error(error);
            });
        */

        effect(() => {
            const keycloakEvent = this.keycloakSignal();

            this.keycloakStatus = keycloakEvent.type;
            
            if (keycloakEvent.type === KeycloakEventType.Ready) {
                console.log("Sidebar KeycloakEventType: Ready");
                console.log("keycloak after event ready: authenticated: " + this.keycloak.authenticated);
            
            } else if (keycloakEvent.type === KeycloakEventType.AuthSuccess) {
                console.log("Sidebar KeycloakEventType: AuthSuccess");
            
            } else if (keycloakEvent.type === KeycloakEventType.TokenExpired) {
                console.log("Sidebar KeycloakEventType: TokenExpired");
                this.logout();

            } else if (keycloakEvent.type === KeycloakEventType.AuthError) {
                console.log("Sidebar KeycloakEventType: AuthError");
                
            } else if (keycloakEvent.type === KeycloakEventType.AuthRefreshSuccess) {
                console.log("Sidebar KeycloakEventType: AuthRefreshSuccess");
                
            } else if (keycloakEvent.type === KeycloakEventType.AuthRefreshError ) {
                console.log("Sidebar KeycloakEventType: AuthRefreshError");
                
            } else if (keycloakEvent.type === KeycloakEventType.AuthLogout ) {
                console.log("Sidebar KeycloakEventType: AuthLogout");
                
            } else if (keycloakEvent.type === KeycloakEventType.KeycloakAngularInit ) {
                console.log("Sidebar KeycloakEventType: KeycloakAngularInit");

            } else if (keycloakEvent.type === KeycloakEventType.KeycloakAngularNotInitialized ) {
                console.log("Sidebar KeycloakEventType: KeycloakAngularNotInitialized");
                
            } else if (keycloakEvent.type === KeycloakEventType.ActionUpdate ) {
                console.log("Sidebar KeycloakEventType: ActionUpdate");
                
            }
        });
        
        /*
        this.msalBroadcastService.msalSubject$
            .pipe(
                filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
            )
            .subscribe((result: EventMessage) => {
                console.log(result);
                // if (result.eventType === EventType.LOGIN_SUCCESS) {
                const payload = result.payload as AuthenticationResult;
                this.msalService.instance.setActiveAccount(payload.account);

                this.initView();
                //}
            });*/
    }
    
    public async ngOnInit() {
        /*this.msalService.handleRedirectObservable().subscribe();

        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                takeUntil(this._destroying$)
            )
            .subscribe((status: InteractionStatus) => {
            })*/
            
        var isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
        
        this.initView();

        isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

        const html = document.getElementsByTagName('html')[0];
        if (isWindows) {
            // if we are on windows OS we activate the perfectScrollbar function
            let ps = new PerfectScrollbar(<HTMLElement>document.querySelector('.sidebar .sidebar-wrapper, .main-panel'));
            html.classList.add('perfect-scrollbar-on');
        } else {
            html.classList.add('perfect-scrollbar-off');
        }
    }

    private async initView() {
        if (this.isLoggedIn() === true) {
            this.menuItems = ROUTES.filter(menuItem => menuItem.RouteRoles.find(role => role.RouteRole === ''));

            // let accountRoles = this.msalService.instance.getActiveAccount()?.idTokenClaims?.roles;
            // let userProfile = await this.keycloak.loadUserProfile;
            // console.log("userProfile:");
            // console.log(userProfile);

            let accessToken = this.keycloak.tokenParsed;

            let accountRoles = [];
            if (accessToken) {
                accountRoles = accessToken['resource_access'][environment.keycloakConfig.clientId]['roles'];            
            }

            for (let item of ROUTES) {
                let itemExists = false;
                let actualChildren = [];

                for (let userRole of accountRoles) {
                    for (let routeRole of item.RouteRoles) {
                        if (routeRole.RouteRole == userRole) {
                            if (!itemExists) {
                                itemExists = true;
                                if (item.children) {
                                    for (let child of item.children) {
                                        let childExists = false;
                                        for (let childUserRole of accountRoles) {
                                            for (let childRole of child.RouteRoles) {
                                                if (childRole.RouteRole == childUserRole || childRole.RouteRole == '') {
                                                    if (!childExists) {
                                                        actualChildren.push(child);
                                                        childExists = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                item.children = actualChildren;
                                this.menuItems.push(item);
                            }
                        }
                    }
                }
            }
        } else {
            this.menuItems = ROUTES.filter(item => item.requireLogin === false);
        }
    }

      
    login() {
        // this.msalService.instance.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
        this.keycloak.login({
            redirectUri: window.location.origin + "/dashboard"
        });
    }


    logout() {
        // this.msalService.instance.logoutRedirect();
        this.keycloak.logout({
            redirectUri: window.location.origin + "/dashboard"
        });
        this.keycloak.clearToken();
    }

    isLoggedIn(): boolean {
        // const loggedIn = this.msalService.instance.getActiveAccount() != null;
        // return loggedIn;
        return this.keycloak.authenticated;
    }

    private _userInfo: UserModel;

    userInfo(): UserModel {
        // return this.msalService.instance.getActiveAccount();
        // let userProfile = await this.keycloak.loadUserProfile();
        // console.log("userProfile:");
        // console.log(userProfile);
        // return userProfile;

        let accessToken = this.keycloak.tokenParsed;

        // console.log("userInfo: ");
        // console.log(accessToken);

        if (accessToken) {
            if (this._userInfo) {
                return this._userInfo;
            }

            let org = Object.values(accessToken['organization'])[0];

            let institutionStudySites: OrganizationModel = {
                City: org['city'][0],
                Name: org['name'][0],
                PostalCode: org['postal_code'][0],
                Street: org['street'][0],
                Country: org['country'][0]
            }
            
            this._userInfo = {
                Name: accessToken['name'],
                PreferredUsername: accessToken['preferred_username'],
                IdTokenClaims: {
                    Roles: accessToken['resource_access'][environment.keycloakConfig.clientId]['roles']
                },
                FamilyName: accessToken['family_name'],
                GivenName: accessToken['given_name'],
                Email: accessToken['email'],
                PhoneNumber: accessToken['phone_number'],
                InstitutionsStudySites: institutionStudySites
            };
        }

        return this._userInfo;
    }

    ngAfterViewInit(){
        var $sidebarParent = $('.sidebar .nav > li.active .collapse li.active > a').parent().parent().parent();
        var collapseId = $sidebarParent.siblings('a').attr("href");
        $(collapseId).collapse("show");
    }
}
